import React from "react";
import classNames from "classnames";
import "./styles.css";

interface InputProps {
    className?: string;
    title: string;
    placeholder?: string;
    type?: "number" | "text" | "datetime-local" | "time" | "date";
    value: string;
    onChange(val: string): void;
    onKeyPress?(e: React.KeyboardEvent<HTMLInputElement>): void;
    icon?: "email" | "date" | "text";
    iconText?: string;
    error?: boolean;
    disabled?: boolean;
    required?: boolean;
}

const Input: React.FC<InputProps> = ({
    onChange,
    title,
    value,
    required = false,
    className = "",
    disabled = false,
    error = false,
    icon,
    iconText,
    onKeyPress,
    placeholder,
    type = "text",
}) => {
    const [isFocused, setIsFocused] = React.useState<boolean>(false);

    return (
        <div
            className={classNames(`input ${className}`, {
                "input--focused": isFocused,
                "input--error": error,
            })}
        >
            {title && (
                <div className="input__title">
                    {title}
                    {required && <span className="input__required">*</span>}
                </div>
            )}
            <div className="input__wrap">
                <input
                    className="input__input"
                    type={type}
                    name="name"
                    placeholder={placeholder}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    onFocus={(e) => setIsFocused(true)}
                    onBlur={(e) => setIsFocused(false)}
                    onKeyPress={(e) => {
                        if (onKeyPress) {
                            onKeyPress(e);
                        }
                    }}
                    autoComplete="off"
                    disabled={disabled || false}
                />
                {icon && icon === "email" && <div className="input__email"></div>}
                {/* {props?.icon && props?.icon === "date" && <div className="input__date"></div>} */}
                {icon && icon === "text" && iconText && <div className="input__icon-text">{iconText}</div>}
            </div>
        </div>
    );
};

export default Input;
